<template>
  <el-select
    v-model="model.product"
    filterable
    remote
    reserve-keyword
    clearable
    value-key="id"
    :remote-method="fetchSearchedProducts"
    :loading="loading"
    @change="selectProduct"
    :loading-text="$t('loading')"
    :placeholder="myPlaceHolder"
    :no-data-text="$t('products.noProductsFound')"
    :disabled="disabled"
    @clear="$emit('clear')">
    <el-option
      v-for="product in searchedProducts"
      :key="product.id"
      :label="showCMSName === false ? product.name : product.cmsName"
      :value="product">
      <span v-if="showCMSName == false">{{getProductName(product)}}</span>
      <span v-else>{{getProductName(product, 'cmsName')}}</span>
    </el-option>
  </el-select>
</template>
<script>
import ProductsApi from '@/services/API/product'
import ProductUtil from '@/utils/product-util'
export default {
	name: 'SelectProduct',
  props: {
		product : {
      type : Object
    },
    inventoryId : {
      type : Number,
      default: undefined,
    },
    type: {
      type: Number,
      default: undefined,
    },
    active : {
      type : Boolean,
      default : true
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    summary: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: true
    },
    showCMSName : {
      type: Boolean,
      default: false,
    },
    placeholder : {
      type: String,
      default: null,
    }
	},
	data() {
		return {
      model : {
        product : null
      },
      searchedProducts : [],
      loading : false,
	   }
   },
  computed: {
    myPlaceHolder(){
      if (this.placeholder == null) {
        return this.$i18n.t('common.select.placeholder');
      }
      return this.placeholder;
    }
  },
  components : {

  },
  methods : {
    getProductName(product, type){
      return ProductUtil.productName(product, type);
    },
    selectProduct(product){
      this.$emit('selected', product);
      if (!this.selected) {
        this.model.product = null;
      }
    },
    fetchSearchedProducts(query){
      this.loading = true;
      if (this.showCMSName === false) {
        return ProductsApi.listProductsV2({searchTerms:query,paging:'no', active:this.active, type: this.type, inventoryId: this.inventoryId, summary: this.summary})
          .then(searchedProducts => {
            this.searchedProducts = searchedProducts;
            this.loading = false;
          });
      } else {
        return ProductsApi.listProductDefinitionV2({searchTerms:query,paging:'no', limit:10, active:this.active, type: this.type, inventoryId: this.inventoryId, summary: this.true})
          .then(searchedProducts => {
            this.searchedProducts = searchedProducts;
            this.loading = false;
          });
      }
      
    },
    getProductById(productId){
      if (this.showCMSName === false) {
        return ProductsApi.getProductV2(productId);
      }
      else {
        return ProductsApi.getProductDefinitionV2(productId);
      }
    },
  },
  watch: {
    product: function (val) {
      if(val==null){
        this.model.product = null;
      }else{
        this.model.product = val;
        this.searchedProducts.splice(0);
        this.searchedProducts.push(val);
      }
    }
  },
  created(){
    if(this.product!=null){
      this.getProductById(this.product.id)
        .then(product=>{
          this.searchedProducts.push(product);
          this.model.product = product;
          this.selectProduct(product)
        })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
